<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <Dialog
            v-if="$vuetify.breakpoint.smAndDown"
            :header-text="calendarEventName"
            :value="isMenuOpen"
            @input="isMenuOpen = $event"
        >
            <template #activator="{ on }">
                <CalendarEventActivator
                    :on="on"
                    :calendar-event="calendarEvent"
                    :is-menu-open="isMenuOpen"
                />
            </template>
            <div style="margin-left: -6px">
                <CalendarEventContent
                    :calendar-event="calendarEvent"
                    @close="isMenuOpen = false"
                />
            </div>
        </Dialog>
        <v-menu
            v-else
            offset-x
            max-width="500"
            min-width="300"
            v-model="isMenuOpen"
            :close-on-content-click="false"
        >
            <template #activator="{ on }">
                <CalendarEventActivator
                    :on="on"
                    :calendar-event="calendarEvent"
                    :is-menu-open="isMenuOpen"
                />
            </template>
            <div class="white">
                <div class="d-flex pa-3 pl-4 pb-0">
                    <div
                        style="padding-top: 6px"
                        class="body-1 font-weight-medium"
                    >
                        {{ calendarEventName }}
                    </div>
                    <v-spacer />
                    <div class="d-flex align-center">
                        <icon-button
                            v-if="can_edit_account(calendarEvent.company_id) && ['company_event', 'company_free_time'].includes(calendarEvent.type) && $vuetify.breakpoint.mdAndUp"
                            icon="Pencil"
                            button-small
                            small
                            @click="$emit('edit-company-event')"
                        />
                        <icon-button
                            icon="X"
                            button-small
                            small
                            @click="isMenuOpen = false"
                        />
                    </div>
                </div>
                <div class="px-2 pb-2">
                    <CalendarEventContent
                        :calendar-event="calendarEvent"
                        @close="isMenuOpen = false"
                    />
                </div>
            </div>
        </v-menu>
    </div>
</template>

<script>
import AccountAvatar from "@/components/AccountAvatar.vue";
import ClientAvatar from "@/components/ClientAvatar.vue";
import CalendarEventActivator from "@/views/Calendar/CalendarEventActivator.vue";
import {computed, ref} from "@vue/composition-api";
import CalendarEventContent from "@/views/Calendar/CalendarEventContent.vue";
import Dialog from "@/components/Dialog";
import RightsModule from "@/composables/use-rights";
import {$t} from "@/i18n";

export default {
    name: "CalendarEvent",
    components: {
        CalendarEventContent,
        ClientAvatar,
        AccountAvatar,
        CalendarEventActivator,
        Dialog
    },
    props: {
        calendarEvent: {
            type: Object,
            required: true
        }
    },
    setup(props, ctx) {
        const { can_edit_account } = RightsModule();

        const isMenuOpen = ref(false);

        const calendarEventName = computed(() => {
            if (!props.calendarEvent.events) {
                if (props.calendarEvent.type === 'contact_birthday') {
                    return $t('Contact birthday')
                } else if (props.calendarEvent.type === 'member_birthday') {
                    return $t('Member birthday')
                }
            }

            return props.calendarEvent.name
        })

        return {
            isMenuOpen,
            can_edit_account,
            calendarEventName
        };
    }
};
</script>
